import { render, staticRenderFns } from "./BulkSMS.vue?vue&type=template&id=0d6e876c&"
import script from "./BulkSMS.vue?vue&type=script&lang=js&"
export * from "./BulkSMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports